import { Pipe, PipeTransform } from '@angular/core';
import { Cliente } from '../../modelos/cliente';

@Pipe({
  name: 'filtroClientes'
})
export class FiltroClientesPipe implements PipeTransform {

  transform(clientes: Cliente[], filtro?: string): any {
    if (clientes === undefined || filtro === undefined || filtro.trim() === '') {
      return clientes;
    }
    filtro = filtro.toLocaleLowerCase();
    return clientes.filter(cliente => cliente.obterRazaoSocial.toLocaleLowerCase().indexOf(filtro) >= 0);
  }

}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/comum/filtros/pipes/filtro-clientes.pipe.ts